import { ITlfActionSetVariantPatchSelection, TlfContextProps } from "./interface";
import { updateVariantPatchSelection } from "./updateVariantPatchSelection";

/**
 * Stores the applied patch set and the single patch currently receiving edits.
 *
 * @param state - Current TLF context state
 * @param action - Applied and active patch selection
 * @returns Updated TLF context state
 */
export const tlf_setVariantPatchSelection = (
  state: TlfContextProps,
  action: ITlfActionSetVariantPatchSelection,
): TlfContextProps =>
  updateVariantPatchSelection(state, action.appliedPatchNames, action.activePatchName);
